// document.addEventListener("click", function(e){

//   const btn = e.target.closest(".cart-remove-bundle");

//   if(!btn) return;

//   e.preventDefault();

//   const bundleId = btn.dataset.bundleId;
//   const removeKey = btn.dataset.removeKey;

//   if(bundleId){

//     removeBundleAndClicked(bundleId, removeKey);

//   }else{

//     removeSingle(removeKey);

//   }

// });



// function removeBundleAndClicked(bundleId, removeKey){

//   fetch("/cart.js")
//   .then(res => res.json())
//   .then(cart => {

//     let updates = {};

//     cart.items.forEach(item => {

//       if(
//         item.key == removeKey ||
//         (item.properties && item.properties._bundleId == bundleId)
//       ){

//         updates[item.key] = 0;

//       }

//     });

//     return fetch("/cart/update.js",{

//       method:"POST",

//       headers:{
//         "Content-Type":"application/json"
//       },

//       body: JSON.stringify({
//         updates: updates
//       })

//     });

//   })
//   .then(()=>{
//     refreshCartDrawer();
//   });

// }



// function removeSingle(key){

// fetch('/cart/update.js',{

// method:'POST',

// headers:{
// 'Content-Type':'application/json'
// },

// body: JSON.stringify({

// updates:{
// [key]:0

// }

// })

// })
// .then(()=>{
// refreshCartDrawer();
// });

// }



// function refreshCartDrawer(){

//   fetch("/cart?view=ajax")
//   .then(res => res.text())
//   .then(html => {

//     const cartItems = document.querySelector(".cart__items");

//     if(cartItems){

//       const temp = document.createElement("div");

//       temp.innerHTML = html;

//       const newItems = temp.querySelector(".cart__items");

//       if(newItems){

//         cartItems.innerHTML = newItems.innerHTML;

//       }

//     }

//   });

// }






// 2 

// document.addEventListener("click", function(e){

//   const btn = e.target.closest(".cart-remove-bundle");

//   if(!btn) return;

//   e.preventDefault();

//   const bundleId = btn.dataset.bundleId;
//   const removeKey = btn.dataset.removeKey;


//   fetch("/cart.js")
//   .then(res => res.json())
//   .then(cart => {

//     let linesToRemove = [];

//     cart.items.forEach((item, index) => {

//       const itemBundleId = item.properties ? item.properties._bundleId : null;

//       if(
//         item.key === removeKey ||
//         (bundleId && itemBundleId == bundleId)
//       ){

//         linesToRemove.push(index + 1);

//       }

//     });


//     // ✅ reverse order VERY IMPORTANT
//     linesToRemove.reverse();


//     let promises = linesToRemove.map(line => {

//       return fetch("/cart/change.js", {

//         method: "POST",

//         headers: {
//           "Content-Type": "application/json"
//         },

//         body: JSON.stringify({

//           line: line,
//           quantity: 0

//         })

//       });

//     });


//     return Promise.all(promises);

//   })
//   .then(() => {

//     reloadPipelineCart();

//   });

// });



// function reloadPipelineCart(){

//   fetch("/cart?view=ajax")
//   .then(res => res.text())
//   .then(html => {

//     const container = document.querySelector(".cart__items");

//     if(!container){

//       location.reload();

//       return;

//     }

//     const div = document.createElement("div");

//     div.innerHTML = html;

//     const newItems = div.querySelector(".cart__items");

//     if(newItems){

//       container.innerHTML = newItems.innerHTML;

//     }else{

//       location.reload();

//     }

//   });

// }




// ================================
// Bundle / Single Remove Functionality
// ================================

// Event delegation: works even after cart reload
document.addEventListener("click", function(e) {
  const btn = e.target.closest(".cart-remove-bundle");
  if (!btn) return;

  e.preventDefault();

  const bundleId = btn.dataset.bundleId;
  const removeKey = btn.dataset.removeKey;

  if (bundleId) {
    removeBundleAndClicked(bundleId, removeKey);
  } else {
    removeSingle(removeKey);
  }
});

// Remove all items in the bundle + clicked item
// function removeBundleAndClicked(bundleId, removeKey) {
//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cart => {
//       const linesToRemove = [];

//       cart.items.forEach((item, index) => {
//         const itemBundleId = item.properties ? item.properties._bundleId : null;

//         if (item.key === removeKey || (itemBundleId && String(itemBundleId) === String(bundleId))) {
//           linesToRemove.push(index + 1); // Shopify cart lines are 1-based
//         }
//       });

//       // Reverse order is important to avoid shifting line numbers
//       linesToRemove.reverse();

//       const promises = linesToRemove.map(line =>
//         fetch("/cart/change.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ line: line, quantity: 0 })
//         })
//       );

//       return Promise.all(promises);
//     })
//     .then(() => refreshCartDrawer())
//     .catch(err => console.error("Bundle remove error:", err));
// }



function removeBundleAndClicked(removeKey, bundleId) {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const linesToRemove = [];

      cart.items.forEach((item, index) => {
        const itemBundleId = item.properties?._bundleId;

        // If bundleId exists → remove whole bundle
        if (bundleId) {
          if (itemBundleId && String(itemBundleId) === String(bundleId)) {
            linesToRemove.push(index + 1);
          }
        } 
        // Otherwise remove only clicked item
        else if (item.key === removeKey) {
          linesToRemove.push(index + 1);
        }
      });

      if (!linesToRemove.length) return;

      return Promise.all(
        linesToRemove.reverse().map(line =>
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ line, quantity: 0 })
          })
        )
      );
    })
    .then(() => refreshCartDrawer())
    .catch(err => console.error("Bundle remove error:", err));
}



// Remove a single item
function removeSingle(key) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates: { [key]: 0 } })
  })
    .then(() => refreshCartDrawer())
    .catch(err => console.error("Single remove error:", err));
}

// Reload / refresh cart drawer dynamically
function refreshCartDrawer() {
  fetch("/cart?view=ajax")
    .then(res => res.text())
    .then(html => {
      const container = document.querySelector(".cart__items");
      if (!container) {
        location.reload(); // fallback
        return;
      }

      const temp = document.createElement("div");
      temp.innerHTML = html;
      const newItems = temp.querySelector(".cart__items");

      if (newItems) {
        container.innerHTML = newItems.innerHTML;
      } else {
        location.reload();
      }
    })
    .catch(err => console.error("Cart refresh error:", err));
}

// ================================
// loadForm integration
// ================================
// function loadForm(plain = false) {
//   if (plain) {
//     showForm();
//     initQuantity();
//     initQuickview();
//     updateTotal();
//     return;
//   }

//   window
//     .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
//     .then(handleErrors)
//     .then(response => response.text())
//     .then(response => {
//       const fresh = document.createElement("div");
//       fresh.innerHTML = response;

//       const itemsContainer = document.querySelector(".cart__items");
//       const newItems = fresh.querySelector(".cart__items");
//       if (itemsContainer && newItems) {
//         itemsContainer.innerHTML = newItems.innerHTML;
//       }

//       showForm();
//       initQuantity();
//       initQuickview();
//       updateTotal();
//     })
//     .catch(err => console.error("loadForm error:", err));
// }